export default "__VITE_ASSET__BsP4YCgh__"